

















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { getUrlParams } from '@/api/http-constants'
import { getModule } from 'vuex-module-decorators'
import { UserModule } from '@//store/modules/user'
import FooterSignin from '@/components/FooterSignin.vue'
import Alert from '@/components/Alert.vue'
import router from '@/router'
import get from 'lodash/get'

@Component({
    components: {
        FooterSignin,
        Alert,
    },
})
export default class Signin extends Vue {
    apiService = new ApiService()
    pwdType = 'password'
    formErrors = []
    user = {
        username: '',
        password: '',
    }

    resetPassword = false

    showPwd() {
        if (this.pwdType === 'password') {
            this.pwdType = ''
        } else {
            this.pwdType = 'password'
        }
    }

    operation = ''

    loginRules = {
        username: [{ required: true, trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur' }],
    }
    loading = false
    errors = []

    errors_types = {
        email: false,
        password: false,
    }

    created() {
        //getUrl
        const url = window.location.hostname.split('.')
        if (url[0] != 'yvivre' && url[0] != 'app') {
            this.operation = url[0]
        }
    }

    mounted() {
        let params = getUrlParams()
        if (params['from'] != undefined && params['from'] == 'logout') {
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                'Vous êtes déconnecté'
            )
        }
    }

    showResetPassword(show = true) {
        console.log('test')
        this.resetPassword = show
    }

    validEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    handleLogin(e) {
        this.errors_types = {
            email: false,
            password: false,
        }

        e.preventDefault()
        this.errors = []

        if (!this.validEmail(this.user.username)) {
            //this.errors.push('Email non valide');
            this.errors_types.email = true
        }

        if (!this.errors.length) {
            this.loading = true
            UserModule.Login(this.user)
                .then(() => {
                    router.push({ name: 'select-ope' })
                })
                .catch(error => {
                    //this.errors.push('Identifiants non valide');
                    console.log(error)
                    this.errors_types.password = true
                })
        } else {
            this.errors.push('Erreur de connexion')
            return false
        }
    }

    async handleResetPassword(e) {
        this.errors_types = {
            email: false,
            password: false,
        }

        e.preventDefault()
        console.log('handle')
        this.errors = []

        if (!this.validEmail(this.user.username)) {
            //this.errors.push('Email non valide');
            this.errors_types.email = true
        }

        if (!this.errors.length) {
            this.loading = true
            console.log('API ResetPassword')
            try {
                const resp = await this.apiService.postResetPasswordRequest({
                    email: this.user.username,
                })
                const message = get(
                    resp,
                    'data.message',
                    'Vous allez recevoir un mail pour réinitialiser votre mot de passe'
                )
                ;(<Alert>this.$refs.alert).handleAlert('success', message)
            } catch (e) {
                const message = get(
                    e,
                    'data.message',
                    "Une erreur est survenue lors de l'envoi de la requête"
                )
                ;(<Alert>this.$refs.alert).handleAlert('danger', message, 7000)
            }
        } else {
            this.errors.push('Erreur de réinitialisation du mot de passe')
            return false
        }
    }
}
